import React, { PropsWithChildren } from 'react';
import { Dialog as DialogMUI, DialogActions, makeStyles, Theme } from '@material-ui/core';
import { Button, Header } from '@hwm/ui-lib';
import { Trans } from '@lingui/macro';

const useStyles = makeStyles((theme: Theme) => ({
  dialog: {
    padding: theme.spacing(5, 4, 2),
  },
  header: {
    height: 40,
    minHeight: 40,
  },
}));

interface DialogModalProps extends PropsWithChildren {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  fullWidth?: boolean;
  dialogClass?: string;
  headerTitle: string;
  headerSubtitle?: string;
  headerDivider?: boolean;
  headerButtons?: JSX.Element[];
  actionButtons?: JSX.Element[];
}

export const DialogModal: React.FC<DialogModalProps> = ({
  show,
  setShow,
  fullWidth,
  dialogClass,
  headerTitle,
  headerSubtitle,
  headerDivider = false,
  headerButtons,
  actionButtons,
  children,
}) => {
  const classes = useStyles();

  return (
    <DialogMUI
      open={show}
      onBackdropClick={() => setShow(false)}
      maxWidth={fullWidth ? 'xs' : null}
      fullWidth={fullWidth}
      classes={{ paper: dialogClass ? dialogClass : classes.dialog }}
    >
      <Header
        title={headerTitle}
        subtitle={headerSubtitle}
        showDivider={headerDivider}
        buttons={headerButtons ? headerButtons.map((btn, i) => <React.Fragment key={i}>{btn}</React.Fragment>) : null}
        buttonsContainerClasses="flex justify-end"
        labelContainerClasses={classes.header}
      />
      {children}
      <DialogActions>
        {actionButtons?.map((btn, i) => <React.Fragment key={i}>{btn}</React.Fragment>)}
        <Button variant="outlined" style={{}} className={actionButtons ? '' : 'w-full'} onClick={() => setShow(false)}>
          <Trans>Close</Trans>
        </Button>
      </DialogActions>
    </DialogMUI>
  );
};
